import type { ReactNode } from 'react';

export const symbol_cards_stack: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M280-296q-24 0-42-18t-18-42v-424q0-24 18-42t42-18h540q24 0 42 18t18 42v424q0 24-18 42t-42 18H280Zm0-60h540v-424H280v424Zm0 0v-424 424Zm-54 178Zm454-430q12 0 21-8.63 9-8.62 9-21.37 0-12-9-21t-21-9H419q-12 0-20.5 9t-8.5 21.5q0 12.5 8.63 21 8.62 8.5 21.37 8.5h260ZM559-468q12 0 21-8.63 9-8.62 9-21.37 0-12-9-21t-21-9H419q-12 0-20.5 9t-8.5 21.5q0 12.5 8.63 21 8.62 8.5 21.37 8.5h139ZM232-118q-24 3-43.61-12.07Q168.77-145.14 165-170l-62-449q-2-12 6-22t20-12q12-1 21.5 6.5T162-627l64 449 320.92-38.62L739-240q12-2 21.5 5.5T772-214q2 12-5.5 22T746-180l-514 62Z"
		/>
	</svg>
);
